import { useEffect, useState } from 'react';

import { getAPX } from '../ui';

interface IResize {
  apx: number;
  windowWidth: number;
}

// thanks to https://gist.github.com/gaearon/cb5add26336003ed8c0004c4ba820eae?source=post_page
export const useResizeHandler = () => {
  const [windowWidth, setAPX] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setAPX(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return { apx: getAPX(windowWidth), windowWidth };
};

export const ResizeHandler = ({ children }: { children: (resize: IResize) => any }) => {
  const resize = useResizeHandler();

  return children(resize);
};
